import { useQueryClient } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'api';
import { DfiReportResponse } from 'types';

export const useSetDataDfiAnnualReportCompleted = (): ((
  report: DfiReportResponse
) => void) => {
  const queryClient = useQueryClient();

  return (report: DfiReportResponse) => {
    queryClient.setQueryData([API_QUERY_KEYS.getDfiAnnualReport], {
      ...report,
      dateCompleted: new Date(),
    });
  };
};
